module.exports = __webpack_public_path__ + "static/media/grave_small.9374fc37.jpg";